import { CircleTypes, ProgressTypes } from "./progressDefinitions";

export const getProgressData = ( progressed: number, total: number, progressType?: ProgressTypes, circleType?: CircleTypes) => {
  const progressTypeRes = progressType ? progressType : ProgressTypes.remaining;
  const tooMuchFed = progressed > total;

    if (!total || total <= 0) {
      return { percent: 0, text: 0 };
    }
  
    const percentRaw = (progressed / total) * 100;
    const percent = Math.min(Math.max(percentRaw, 0), 100);
  
    switch (progressTypeRes) {
      case ProgressTypes.consumed:
        return {
          percent: tooMuchFed ? 100 : percent,
          text: circleType === CircleTypes.primary ? progressed : (tooMuchFed ? (total/1000).toFixed(2) : (progressed / 1000).toFixed(2)),
        };
  
      case ProgressTypes.remaining:
        return {
          percent: tooMuchFed ? 0 : 100 - percent,
          text: circleType === CircleTypes.primary ? total-progressed : (tooMuchFed ? 0 : ((total-progressed)/1000).toFixed(2))
        };
  
      default:
        return {
          percent,
          text: Math.round(percent),
        };
    }
  };